/**
 * Detects and ignores errors caused by the autofill
 * scripts in MS Edge browser extensions
 *
 * @param {object} report the Report Object
 * @returns {boolean} Returns true if the report matches
 * @example
 *    "Unspecified error." when using MS Edge"
 */
function edgeAutofillError(report) {
  if (report.errorMessage.includes("Unspecified error") && navigator.userAgent.includes("Edge")) {
    report.ignore();

    return true;
  }

  return false;
}

export default edgeAutofillError;
